import getEnvConfig from '@cld/env-config';

const appConfig = getEnvConfig();

export default appConfig;
